export default __webpack_public_path__ + "static/media/5d011da887ffda0fea850145c8ca50841600874836714.1fbefda2.webp";